import './styles/general.scss';
import "bootstrap";


export function handleOnLoad() {
    setTimeout(function() {
        var emailFields = document.getElementsByClassName("forminator-input");
        for (var i = 0; i < emailFields.length; i++) {
            emailFields[i].onpaste = function(e) {
                e.preventDefault();
            }
            emailFields[i].setAttribute('autocomplete', 'off');
            emailFields[i].setAttribute('aria-autocomplete', 'none'); // workaround for Edge Chromium
        }
    }, 5000);
}


window.onload = () => {
    handleOnLoad()
}

window.onscroll = () => {

}

window.onresize = () => {
}
